import { makeHttpRequest } from "@/shared";

import { mapAdditionalServiceFromServer } from "./mappers/mapAdditionalServicesFromServer";
export const getAdditionalService = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/service/additional/${id}`,
            method: "GET",
        })
    ).data;

    return mapAdditionalServiceFromServer(response.data);
};
